import React from "react";
import { Card, Col, Row } from "antd";
import { renderDynamicField } from "./DynamicFieldRenderer";

export const DynamicFormCard = ({
  themeDefault,
  dynamicFormTemplate,
  clientFormBuilderList,
  dispatch,
  uploadDocumentCustomerDynamicFormAction,
  form,
  isCreateMode,
}) => {
  const shouldShowCard =
    (dynamicFormTemplate &&
      Array.isArray(dynamicFormTemplate) &&
      dynamicFormTemplate.length > 0 &&
      dynamicFormTemplate[0]?.questions &&
      dynamicFormTemplate[0].questions.length > 0) ||
    (!isCreateMode &&
      clientFormBuilderList?.customerDetails?.questions &&
      Array.isArray(clientFormBuilderList.customerDetails.questions) &&
      clientFormBuilderList.customerDetails.questions.length > 0);

  if (!shouldShowCard) {
    return null;
  }

  const getCardTitle = () => {
    if (
      dynamicFormTemplate &&
      Array.isArray(dynamicFormTemplate) &&
      dynamicFormTemplate.length > 0
    ) {
      return dynamicFormTemplate[0]?.formTemplateName;
    }
    if (clientFormBuilderList?.customerDetails?.formTemplateId) {
      return "Additional Information";
    }
    return "Additional Information";
  };

  return (
    <Col span={24}>
      <Card
        bordered
        title={
          <div
            style={{
              borderBottom: themeDefault?.info?.newConfig?.cardborder,
              paddingBottom: 8,
            }}
          >
            {getCardTitle()}
          </div>
        }
      >
        <Row gutter={[16, 16]}>
          {dynamicFormTemplate &&
          Array.isArray(dynamicFormTemplate) &&
          dynamicFormTemplate.length > 0 &&
          dynamicFormTemplate[0]?.questions &&
          dynamicFormTemplate[0].questions.length > 0
            ? dynamicFormTemplate[0].questions.map((question, index) =>
                renderDynamicField(
                  question,
                  index,
                  dispatch,
                  uploadDocumentCustomerDynamicFormAction,
                  form
                )
              )
            : !isCreateMode &&
              clientFormBuilderList?.customerDetails?.questions &&
              Array.isArray(clientFormBuilderList.customerDetails.questions) &&
              clientFormBuilderList.customerDetails.questions.length > 0
            ? clientFormBuilderList.customerDetails.questions.map(
                (q, index) => {
                  const templateQuestion =
                    dynamicFormTemplate &&
                    Array.isArray(dynamicFormTemplate) &&
                    dynamicFormTemplate.length > 0 &&
                    dynamicFormTemplate[0]?.questions
                      ? dynamicFormTemplate[0].questions.find(
                          (tq) => tq._id === q.questionId
                        )
                      : null;

                  const questionToRender = templateQuestion || {
                    _id: q.questionId,
                    question: `Question ${index + 1}`,
                    answerType: q.answerType,
                    requirement: "optional",
                    fieldColSpan: "24",
                    placeholder: "",
                    description: "",
                    multiOptions: [],
                  };

                  return renderDynamicField(
                    questionToRender,
                    index,
                    dispatch,
                    uploadDocumentCustomerDynamicFormAction,
                    form
                  );
                }
              )
            : null}
        </Row>
      </Card>
    </Col>
  );
};
